import DateUtils from '../../../../utils/date/DateUtils';
export default function formatHoursOfOperation(hours) {
  var DAY_OF_WEEK = {
    1: 'https://schema.org/Monday',
    2: 'https://schema.org/Tuesday',
    3: 'https://schema.org/Wednesday',
    4: 'https://schema.org/Thursady',
    5: 'https://schema.org/Friday',
    6: 'https://schema.org/Saturday',
    7: 'https://schema.org/Sunday'
  };
  if (hours) {
    return hours.map(function (_ref) {
      var day = _ref.day,
        open = _ref.open,
        close = _ref.close;
      var openStr = DateUtils.format(DateUtils.parseHourInt(open), 'HH:mm:ss');
      var closeStr = DateUtils.format(DateUtils.parseHourInt(close), 'HH:mm:ss');
      return {
        '@type': 'OpeningHoursSpecification',
        dayOfWeek: DAY_OF_WEEK[day],
        opens: openStr,
        closes: closeStr
      };
    });
  }
  return null;
}